<template>
  <div>
    <div
      class="h-54 w-55 flex-h flex-v-center"
      @click="onBackPressed()"
      :style="{ background: background }"
    >
      <img class="w-18 h-20 margin-l-15" :src="arrow" />
    </div>
    <div style="line-height: 0.05rem">
      <span
        style="
          position: absolute;
          left: 50%;
          transform: translate(-50%, -50%);
          margin-top: -25px;
        "
        :style="{ color: titleColor }"
        class="font-18 font-bold line-height-17"
        >{{ title }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "tool_bar",
  props: {
    title: {
      type: String,
      default: "",
    },
    background: {
      type: String,
      default: "transparent",
    },
    arrow: {
      type: String,
      default: require("../assets/icon_nav_back.png"),
    },
    titleColor: {
      type: String,
      default: "14171B",
    },
    url: {
      type: String,
      default: "",
    },
  },
  methods: {
    onBackPressed() {
      if (this.url) {
        this.$router.push({ path: this.url });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
</style>